export default {

  name: "adPerformance",

  requiredFields: [
    ['Headline',['HeadlinePart1', 'HeadlinePart2']],
    ['Description', ['Description1', 'Description2']],
    ['DisplayUrl','CreativeDestinationUrl','CreativeFinalUrls']
  ],

  numericFields: ['Clicks', 'Impressions', 'Cost', 'Conversions', 'ConversionValue'],

  languages: [
    {
      lang: 'pl',
      columnTranslation: {
        'Kliknięcia' : 'Clicks',
        'Wyświetlenia' : 'Impressions',
        'Koszt' : 'Cost',
        'Konwersje' : 'Conversions',
        'Wartość wszystkich konw.' : 'ConversionValue',

        'Reklama': 'Headline',
        'Nagłówek 1': 'HeadlinePart1',
        'Nagłówek 2': 'HeadlinePart2',
        'Nagłówek 3': 'HeadlinePart3',
        'Linia tekstu 1': 'Description1',
        'Linia tekstu 2': 'Description2',
        'Tekst reklamy': 'Description',
        'Wyświetlany URL': 'DisplayUrl',
        "Końcowy URL": "CreativeFinalUrls",
        "Docelowy URL": "CreativeDestinationUrl",

        'Kampania' : 'CampaignName',
        'Grupa reklam' : 'AdGroupName'
      },
      summaryRegex: [/^Łącznie/i, /^Razem/i]
    },
    {
      lang: 'en',
      columnTranslation: {
        'Clicks' : 'Clicks',
        'Impressions' : 'Impressions',
        'Cost' : 'Cost',
        'Conversions' : 'Conversions',
        'All conv. value': 'ConversionValue',

        'Headline': 'Headline',
        'Headline 1': 'HeadlinePart1',
        'Headline 2': 'HeadlinePart2',
        'Headline 3': 'HeadlinePart3',
        'Description line 1': 'Description1',
        'Description line 2': 'Description2',
        'Description': 'Description',
        'Display URL': 'DisplayUrl',
        "Final URL": "CreativeFinalUrls",
        "Destination URL": "CreativeDestinationUrl",

        'Campaign' : 'CampaignName',
        'Ad group' : 'AdGroupName',
      },
      summaryRegex: [/^Total/i]
    }
  ],



}



// WEBPACK FOOTER //
// ./src/config/input/adPerformance.js